// Fixes "TS2742: The inferred type of 'api' cannot be named without a reference ..."
/// <reference types="@zodios/core" />

import { createApi } from "@skilitics/billing-api-client";
import { getAuthToken } from "@skilitics/designer-auth/state";

// hack until this is pulled out into designer client
const getRequiredAppSetting = (value: string | undefined, key: string): string => {
  if (!value) {
    throw new Error(`Missing required app setting: ${key}`);
  }
  return value;
};

export const api = createApi({
  baseUrl: getRequiredAppSetting(import.meta.env.REACT_APP_BILLING_ENDPOINT, "BILLING_ENDPOINT"),
  tokenProvider: getAuthToken,
});

// The billing client uses axios's fetch adapter, which injects a User-Agent
// header the billing API's CORS allow-list rejects. XHR omits it.
api.axios.defaults.adapter = "xhr";
